module.exports = __webpack_public_path__ + "static/media/star_quarter.53822727.png";